import { render, staticRenderFns } from "./OwnMultiSelectWarehouse.vue?vue&type=template&id=0745b2b6&"
import script from "./OwnMultiSelectWarehouse.vue?vue&type=script&lang=js&"
export * from "./OwnMultiSelectWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports